import { Link } from "react-router-dom";
import React from "react";

export default function BreadCrumb({ pageTitle, to, currentPage, items }) {
  // Support both legacy (to, currentPage) and new (items array) props
  const breadcrumbItems = items || (to && currentPage ? [{ label: currentPage, path: to }] : []);

  const renderSeparator = () => (
    <svg
      width="6"
      height="12"
      viewBox="0 0 6 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 1L5 6L1 11"
        stroke="#794AFF"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  return (
    <section id="h1-breadcrumb">
      <div className="relative w-full py-16 lg:pt-0 md:pt-0 overflow-hidden h1-breadcrumb h-fit bg-[#160e2454] md:pb-[153px]">
        {/* <WinGridBg /> */}
        <div className="absolute left-1/4 w-full top-[300px] overflow-hidden z-0 pointer-events-none">
          <div className="flex justify-center">
            <img src="/assets/images/home-one-hero-circle-shadow.svg" alt="" />
          </div>
        </div>
        <div className="relative z-20 mx-auto theme-container h-fit w-fit px-4">
          <div className="mt-20 sm:mt-[120px] md:mt-[272px] w-fit mx-auto relative z-10">
            <h1 className="w-full font-semibold text-center text-white text-24 sm:text-34 md:text-48">
              {pageTitle}
            </h1>
            <div className="flex items-center justify-center gap-3 sm:gap-5 mt-4">
              <Link
                to="/"
                className="relative leading-5 transition-all duration-300 home-two-nav-item text-18 font-inter text-paragraph hover:text-purple"
              >
                Home
              </Link>
              {breadcrumbItems.map((item, index) => (
                <React.Fragment key={index}>
                  {renderSeparator()}
                  <Link
                    to={item.path}
                    className="relative leading-5 transition-all duration-300 home-two-nav-item text-18 font-inter text-paragraph hover:text-purple"
                  >
                    {item.label}
                  </Link>
                </React.Fragment>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
